module.exports = __webpack_public_path__ + "img/borescope_protoype1.e5b7895e.jpg";